import {useFinesSecurityApi} from "./useFinesSecurityApi";
import qs from "qs";
import dayjs from "dayjs";
import {HTTPGenericResponse} from "../../finance/constants/FinanceModels";
import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

export const useTheftMisappropriationActions = () => {
    const {GET, POST, PUT} = useFinesSecurityApi();

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
    const allDealers: any[] = user.dealers?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

    async function getTheftMisappropriationList(filters: any) {
        let params = {
            firstName: filters.firstName ? filters.firstName : undefined,
            lastName: filters.lastName ? filters.lastName : undefined,
            rentalAgreement: filters.rentalAgreement ? filters.rentalAgreement : undefined,
            entryUser: filters.entryUser ? filters.entryUser : undefined,
            eventType: filters.eventType != null ? filters.eventType : undefined,
            eventStatus: filters.eventStatus ? filters.eventStatus : undefined,
            openingDateFrom: filters.openingDateFrom ? filters.openingDateFrom : undefined,
            openingDateTo: filters.openingDateTo ? filters.openingDateTo : undefined,
            closingDateFrom: filters.closingDateFrom ? filters.closingDateFrom : undefined,
            closingDateTo: filters.closingDateTo ? filters.closingDateTo : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined,

            tenant: filters.legalEntities ? filters.legalEntities : allLegalEntities,
            dealer: filters.dealers? filters.dealers  : [],
            plate: filters.plate ? filters.plate : undefined,
        };
        let data = await GET("fs/theft-misappropriation", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data.result?.total,
            content: data.result?.content
        };

    }
    async function getSummary(filterDefs:any): Promise<HTTPGenericResponse>{
        let params = {
            firstName: filterDefs.firstName ? filterDefs.firstName : undefined,
            lastName: filterDefs.lastName ? filterDefs.lastName : undefined,
            rentalAgreement: filterDefs.rentalAgreement ? filterDefs.rentalAgreement : undefined,
            entryUser: filterDefs.entryUser ? filterDefs.entryUser : undefined,
            eventType: filterDefs.eventType ? filterDefs.eventType : undefined,
            eventStatus: filterDefs.eventStatus ? filterDefs.eventStatus : undefined,
            openingDateFrom: filterDefs.openingDateFrom ? dayjs(filterDefs.openingDateFrom).toISOString() : null,
            openingDateTo: filterDefs.openingDateTo ? dayjs(filterDefs.openingDateTo).toISOString() : null,
            closingDateFrom: filterDefs.closingDateFrom ? dayjs(filterDefs.closingDateFrom).toISOString() : null,
            closingDateTo: filterDefs.closingDateTo ? dayjs(filterDefs.closingDateTo).toISOString() : null,

            tenant: filterDefs.legalEntities ? filterDefs.legalEntities : allLegalEntities,
            dealers: filterDefs.dealers? filterDefs.dealers : []
        }
        return await GET("fs/theft-misappropriation/eventStatuses/count", true,
            { params: params, paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }


    async function getTheftMisappropriationDetail(id: any) {
            let params = { id: id ? id : undefined   }
            let data = await GET("fs/theft-misappropriation/single" , true,{
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return data.result;

    }

    async function getEventType() {
        return await GET("fs/theft-misappropriation/eventTypes", true);
    }

    async function getEventStatus() {
        return await GET("fs/theft-misappropriation/eventStatuses", true);
    }

    async function createEventCard(payload: any) {
        return await POST("fs/theft-misappropriation/", payload, true)
    }

    async function updateEventCard(payload: any) {
        return await PUT("fs/theft-misappropriation/", payload, true)
    }

    async function downloadReport(tenant: [], dealers: []) {
        let params = {
            tenant: tenant.length > 0 ? tenant : allLegalEntities,
            dealers: dealers.length > 0 ? dealers : allDealers
        }
        return await GET("fs/theft-misappropriation/reports", true, {
            params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        })
    }

    async function searchRentalAgreement(search: string, tenant: string, dealer: string) {
        let payload = {idRentalAgreement: search, tenants: [tenant], dealers: dealer !== "" ? [dealer] : []}
        let data = await POST("fs/theft-misappropriation/ra/search", payload, true)
        return data?.searchRAResponses.map((s: any) => s.idRentalAgreement);
    }

    async function getRentalAgreementById(id: string) {
        return await GET("fs/theft-misappropriation/ra/get/"+id, true);
    }

    async function getVehicleDetailsByPlate(plate: string, params: any) {
        return await GET("fs/theft-misappropriation/vehicle/plate/"+plate, true, {params});
    }
    async function addInvoiceAttachment(file: File, id: string | undefined) {
        let formData = new FormData();
        formData.append("file", file);
        return await POST("fs/theft-misappropriation/attachment/upload?id="+id, formData, true,
            {headers: {"Content-Type": "multipart/form-data"}})
    }
    async function addComplaintAttachment(file: File, id: string | undefined) {
        let formData = new FormData();
        formData.append("file", file);
        return await POST("fs/theft-misappropriation/complaintAttachment/upload?id="+id, formData, true,
            {headers: {"Content-Type": "multipart/form-data"}})
    }

    async function getSingleAttachment(id: number | undefined,  idTheftAndMisappropriation: string | undefined) {
        return await GET("fs/theft-misappropriation/attachment/single?id="+id+"&idTheftAndMisappropriation="+idTheftAndMisappropriation, true);
    }

    async function getSingleComplaintAttachment(id: number | undefined,  idTheftAndMisappropriation: string | undefined) {
        return await GET("fs/theft-misappropriation/complaintAttachment/single?id="+id+"&idTheftAndMisappropriation="+idTheftAndMisappropriation, true);
    }

    async function deleteAttachment(id: number | undefined, idTheftAndMisappropriation: string | undefined) {
        return await GET("fs/theft-misappropriation/attachment/delete?id="+id+"&idTheftAndMisappropriation="+idTheftAndMisappropriation, true);
    }

    async function deleteComplaintAttachment(id: number | undefined, idTheftAndMisappropriation: string | undefined) {
        return await GET("fs/theft-misappropriation/complaintAttachment/delete?id="+id+"&idTheftAndMisappropriation="+idTheftAndMisappropriation, true);
    }

    async function addActivity(payload: any, idTheftAndMisappropriation: string | undefined) {
        return await POST("fs/theft-misappropriation/activity/create?id="+idTheftAndMisappropriation, payload, true);
    }

    async function getActivities(idTheftAndMisappropriation: string | undefined) {
        return await GET("fs/theft-misappropriation/activity?id="+idTheftAndMisappropriation, true);
    }


    async function getTheftMisappropriationOther(id: any, driversIds :any[], tenant: string, dealer: string) {
        let params = {id: id, driversIds: driversIds, tenant: tenant, dealer: dealer}
        let data = await GET("fs/theft-misappropriation/others", true,
            { params: params, paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
        return {
            totalElements: data.result?.total,
            content: data.result?.content
        };

    }
    async function getMessages(idTheftAndMisappropriation: any) {
        return await GET("fs/theft-misappropriation/message?id=" + idTheftAndMisappropriation, true);
    }

    async function getTemplates(params: any) {
        return await GET("fs/theft-misappropriation/templates", true, {params});
    }

    async function sendMessage(payload: any, idTheftMisappropriation: any) {
        return await POST("fs/theft-misappropriation/message/create?id="+idTheftMisappropriation, payload, true)
    }

    async function sendToInvoice(tenant: string, dealer: string) {
        let params = {
            tenant: tenant,
            dealer: dealer
        }
        return await GET("fs/theft-misappropriation/send-to-invoice", true, {params});
    }

    return {
        getTheftMisappropriationList,
        getTheftMisappropriationOther,
        getTheftMisappropriationDetail,
        createEventCard,
        getEventType,
        getEventStatus,
        updateEventCard,
        downloadReport,
        getSummary,
        searchRentalAgreement,
        getRentalAgreementById,
        addInvoiceAttachment,
        addComplaintAttachment,
        getSingleAttachment,
        getSingleComplaintAttachment,
        deleteAttachment,
        deleteComplaintAttachment,
        getMessages,
        getTemplates,
        sendMessage,
        addActivity,
        getActivities,
        getVehicleDetailsByPlate,
        sendToInvoice
    };
}